import $ from 'jquery'
import { ready } from 'shared/ready'
import { trackInternalEvent } from '@rio/tracking'

class BlogBottomStickyCta {
  constructor($el) {
    if (!$el.length) return

    this.$el = $el
    this.$tocToggle = $el.find('.blog-post__sticky-cta-toc-toggle')
    this.$tocContainer = $('.blog-aside-toc')
    this.$backToTop = $el.find(
      '.blog-post__sticky-cta-to-top, .blog-post__sticky-cta-to-top-desktop',
    )
    this.isTocVisible = false

    if (!this.$tocContainer.length) {
      this.$tocToggle.hide()
      return
    }

    this.bindEvents()
  }

  bindEvents() {
    // Handle TOC toggle click
    this.$tocToggle.on('click', this.handleTocToggle.bind(this))

    // Close TOC when clicking outside or on TOC item
    $(document).on('click', this.handleOutsideClick.bind(this))

    // Handle window resize to reset TOC state
    $(window).on('resize', this.handleResize.bind(this))

    // Handle back to top button click
    if (this.$backToTop.length) {
      this.$backToTop.on('click', this.handleBackToTop.bind(this))
    }
  }

  handleTocToggle(e) {
    e.preventDefault()
    e.stopPropagation()

    this.isTocVisible = !this.isTocVisible

    if (this.isTocVisible) {
      this.showToc()
    } else {
      this.hideToc()
    }
  }

  showToc() {
    if (!$('.blog-post__toc-overlay').length) {
      this.createTocOverlay()
    }

    // Show the TOC container
    this.$tocContainer.addClass('blog-post__toc--mobile-visible')
    $('.blog-post__toc-overlay').addClass('blog-post__toc-overlay--visible')

    $('body').addClass('blog-post__body--no-scroll')

    const $stickyCtaContent = $('.blog-post__sticky-cta-content')
    $stickyCtaContent.css('height', '480px').css('display', 'block')

    if ($('.blog-post__sticky-cta-version').text() === 'v2') {
      $stickyCtaContent.css('background', 'var(--blue-10)')
      $('.blog-post__sticky-cta').css('background', 'var(--blue-10)')
      $('.blog-post__sticky-cta-toc-toggle').css('background', '#FFF')
      $('.blog-post__sticky-cta-toc-toggle-icon').css('color', 'var(--blue-50)')
    }

    // Add class to hide back to top button
    this.$el.addClass('blog-post__sticky-cta--toc-open')

    trackInternalEvent('open_table_of_content', {
      label: 'posts',
      block: 'sticky',
      url: window.location.href,
      website_host: window.location.host,
    })
  }

  hideToc() {
    this.$tocContainer.removeClass('blog-post__toc--mobile-visible')
    $('.blog-post__toc-overlay').removeClass('blog-post__toc-overlay--visible')

    $('body').removeClass('blog-post__body--no-scroll')

    const $stickyCtaContent = $('.blog-post__sticky-cta-content')

    $stickyCtaContent.css('height', '0').css('display', 'none')

    if ($('.blog-post__sticky-cta-version').text() === 'v2') {
      $stickyCtaContent.css('background', '#FFF')
      $('.blog-post__sticky-cta').css('background', '#FFF')
      $('.blog-post__sticky-cta-toc-toggle').css('background', 'var(--neutral-10)')
      $('.blog-post__sticky-cta-toc-toggle-icon').css('color', 'var(--neutral-60)')
    }

    // Remove class to show back to top button again
    this.$el.removeClass('blog-post__sticky-cta--toc-open')
  }

  createTocOverlay() {
    const overlay = $('<div class="blog-post__toc-overlay"></div>')
    overlay.on('click', this.hideToc.bind(this))
    $('body').append(overlay)
  }

  handleOutsideClick(e) {
    const $target = $(e.target)
    if (
      this.isTocVisible &&
      (!$target.closest(
        '.blog-post__sticky-cta-title, .blog-post__sticky-cta-toc-toggle, ul, .blog-aside-toc__body',
      ).length ||
        $target.hasClass('blog-aside-toc__item-ul') ||
        $target.hasClass('blog-aside-toc__sub_item-li'))
    ) {
      this.hideToc()
    }
  }

  handleResize() {
    if (this.isTocVisible && window.innerWidth >= 768) {
      this.hideToc()
    }
  }

  handleBackToTop(e) {
    e.preventDefault()
    e.stopPropagation()

    // Use a more reliable scroll method
    $('html, body').animate({ scrollTop: 0 }, 300)

    trackInternalEvent('click_back_to_top', {
      label: 'posts',
      block: 'sticky',
      url: window.location.href,
      website_host: window.location.host,
    })
  }
}

ready(function () {
  $('.blog-post__sticky-cta, .blog-post__sticky-cta-desktop').each(
    (_, el) => new BlogBottomStickyCta($(el)),
  )
})
